// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"1dc06f6b","453":"6a43d835","796":"cb228c8e"}[chunkId] + ".chunk.js";
};